<template>
  <Layout
    :title="title"
  >
    <template v-slot:buttons-prepend>
      <v-btn
        icon
        :to="{name: 'selectProfile'}"
      >
        <v-icon>{{ mdiChevronLeft }}</v-icon>
      </v-btn>

      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            depressed
            active-class="no-active"
            :to="{name: 'home', query: {g: navigation === 'table' ? 'weight' : undefined }}"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ navigation === 'table' ? mdiChartBellCurveCumulative : mdiTable }}</v-icon>
          </v-btn>
        </template>
        Переключиться на {{ navigation === 'table' ? 'графики' : 'таблицу' }}
      </v-tooltip>

    </template>

    <template v-slot:buttons>
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="addMeasureDialogShow"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ mdiPlus }}</v-icon>
          </v-btn>
        </template>
        Добавить измерение
      </v-tooltip>

      <v-menu
        content-class="print-hidden"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>{{ mdiDotsVertical }}</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="navigation !== 'table'"
            @click="doSaveImage"
          >
            <v-list-item-avatar>
              <v-icon>{{ mdiExportVariant }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              Открыть график как изображение
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="doPrintPage">
            <v-list-item-avatar>
              <v-icon>{{ mdiPrinter }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Печать</v-list-item-title>
          </v-list-item>
          <v-list-item @click="doHelp">
            <v-list-item-avatar>
              <v-icon>{{ mdiHelpCircleOutline }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Справка</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </template>

    <template v-slot:content>
      <v-bottom-navigation
        fixed
        hide-on-scroll
        style="height: 80px;"
      >
        <v-btn
          text
          :color="navigation === 'table' ? 'primary': 'default'"
          :to="{name: 'home', query: {}}"
          class="nav-btn"
        >
          <span>Таблица<br>&nbsp;</span>
          <v-icon>{{ mdiTable }}</v-icon>
        </v-btn>

        <v-btn
          v-for="(nav, navKey) in navGraphs"
          :key="navKey"
          text
          :color="navigation === navKey ? 'primary': 'default'"
          :to="{name: 'home', query: {g: navKey}}"
          class="nav-btn"
        >
          <span v-html="nav.name"></span>
          <v-icon>{{ nav.icon }}</v-icon>
        </v-btn>
      </v-bottom-navigation>
      <MeasureList
        v-if="measures.length && navigation === 'table'"
        :title="title"
        :items="measureListSortByDate"
        @edit="editMeasure($event)"
      ></MeasureList>
      <Receipt
        v-else-if="measures.length && navigation === 'receipt'"
        :items="measureListSortByDate"
      ></Receipt>
      <MeasureGraph
        v-else-if="['receipt', 'table'].indexOf(navigation) < 0"
        :title="title"
        :type="navigation"
        :measures="measureListSortByDate"
        ref="measureGraph"
      ></MeasureGraph>
      <v-layout
        v-if="!measures.length && navigation === 'table'"
      >
        <v-flex
          xs12
          class="pa-5 text-center"
        >
          <v-btn
            color="primary"
            @click="addMeasureDialogShow"
          >Добавить измерение
          </v-btn>
        </v-flex>
      </v-layout>
      <v-sheet class="print-hidden" height="72"></v-sheet>
      <MeasureDialog
        v-if="dialogShow"
        v-model="dialogShow"
        :title="dialogTitle"
        :measure="measure"
        @close="dialogShow = false"
        @save="saveMeasure"
        @remove="deleteMeasure"
      ></MeasureDialog>
      <v-dialog
        v-model="dialogHelpShow"
        :max-width="maxWidth"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            Справка
          </v-toolbar>
          <v-card-text class="mt-5">
            <Help/>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              @click="dialogHelpShow = false"
            >Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </Layout>
</template>

<script>
import {
  mdiChevronLeft,
  mdiPlus,
  mdiTable,
  mdiChartBellCurveCumulative,
  mdiExportVariant,
  mdiDotsVertical,
  mdiPrinter,
  mdiHelpCircleOutline,
  mdiAbacus
} from '@mdi/js'

import Layout from '@/components/Layout'
import Help from '@/components/Help'
import MeasureDialog from '@/components/MeasureDialog'

import measureDB from '@/app/measure'
import utils from '@/app/utils'
import profileDB from '@/app/profile'
import config from '@/app/config'

const MeasureList = () => import('@/components/MeasureList')
const MeasureGraph = () => import('@/components/MeasureGraph')
const Receipt = () => import('@/components/Receipt')

export default {
  components: {
    Layout,
    Help,
    MeasureDialog,
    MeasureList,
    MeasureGraph,
    Receipt
  },
  data () {
    return {
      mdiChevronLeft,
      mdiPlus,
      mdiTable,
      mdiChartBellCurveCumulative,
      mdiExportVariant,
      mdiDotsVertical,
      mdiPrinter,
      mdiHelpCircleOutline,
      mdiAbacus,
      dialogTitle: '',
      measure: {},
      measures: [],
      dialogShow: false,
      dialogHelpShow: false,
      navigation: 'table',
      isTest: false
    }
  },
  mounted () {
    if (process.env.VUE_APP_MIGRATE_TO || !this.activeProfile || !this.activeProfile.id) {
      this.$router.push({ name: 'selectProfile' })
    } else {
      measureDB.getItems().then(items => {
        this.measures = items
      })
    }
    this.$watch('$route.query.g', (value) => {
      if (!value) {
        this.navigation = 'table'
      } else {
        this.navigation = value
      }
    }, {
      immediate: true
    })
    if ((typeof (this.$route.query.test) !== 'undefined') && window.localStorage) {
      if (this.$route.query.test) {
        localStorage.setItem('test', 1)
      } else {
        localStorage.removeItem('test')
      }
    }
    this.isTest = window.localStorage.getItem('test')
  },
  computed: {
    maxWidth () {
      return config.maxWidth
    },
    activeProfile () {
      return this.$store.state.profile
    },
    title () {
      return this.activeProfile ? (this.activeProfile.name +
          '<br><small>(' +
          profileDB.levelName(this.activeProfile.disability, true) +
          ', ' +
          utils.getDateDmy(new Date(this.activeProfile.birthdate)) +
          ')</small>') : ''
    },
    measureListSortByDate () {
      return [...this.measures].sort((a, b) => Number(new Date(a.dt)) - Number(new Date(b.dt)))
    },
    navGraphs () {
      let nav = {
        stature: {
          name: 'Рост<br>&nbsp;',
          icon: mdiChartBellCurveCumulative
        },
        weight: {
          name: 'Вес<br>&nbsp;',
          icon: mdiChartBellCurveCumulative
        },
        bmi: {
          name: 'Индекс<br>массы',
          icon: mdiChartBellCurveCumulative
        },
        receipt: {
          name: 'Нутритивный<br>статус',
          icon: mdiAbacus
        }
      }
      return nav
    }
  },
  methods: {
    initMeasure (editedMeasure = null) {
      let dtNow = ''
      if (!editedMeasure) {
        dtNow = utils.getDateYmd(new Date())
        if (this.measureExistsByDate(dtNow)) {
          dtNow = ''
        }
      }
      let defaults = {
        dt: dtNow,
        stature: '',
        weight: ''
      }
      if (editedMeasure) {
        this.measure = {
          ...defaults,
          ...editedMeasure
        }
      } else {
        this.measure = Object.assign({}, defaults)
      }
    },
    addMeasureDialogShow () {
      this.dialogShow = true
      this.dialogTitle = 'Добавление измерения'
      this.initMeasure()
    },
    saveMeasure (measure) {
      let finded = false
      for (let i in this.measures) {
        if (this.measures[i].id === measure.id) {
          finded = true
          this.$set(this.measures, i, measure)
          break
        }
      }
      if (!finded) {
        this.measures.push(measure)
      }
      this.dialogShow = false
    },
    editMeasure (measure) {
      this.dialogShow = true
      this.dialogTitle = 'Редактирование измерения'
      this.initMeasure(measure)
    },
    deleteMeasure (measure) {
      for (let i in this.measures) {
        if (this.measures[i].id === measure.id) {
          this.measures.splice(parseInt(i), 1)
          break
        }
      }
    },
    measureExistsByDate (dt) {
      for (let i in this.measures) {
        if (this.measures[i].dt === dt) {
          return true
        }
      }
      return false
    },
    doSaveImage () {
      if (this.$refs.measureGraph && this.$refs.measureGraph.$el) {
        let tags = this.$refs.measureGraph.$el.getElementsByTagName('canvas')
        if (tags.length) {
          let canvas = tags[0]
          let dataURL = canvas.toDataURL('image/png')
          window.open().document.write('<img src="' + dataURL + '"/>')
        }
      }
    },
    doPrintPage () {
      window.print()
    },
    doHelp () {
      this.dialogHelpShow = true
    }
  }
}
</script>

<style type="text/stylus" lang="stylus">
  .v-btn--active.no-active:not(:hover)::before {
    opacity 0 !important
  }
</style>
